export const EmailReportType = {
  FULL: 'full',
  BY_COMPANY: 'by_company',
  BY_DISPLAY: 'by_display',
  BY_ZONE: 'by_zone',
};

export const EmailReportFormat = {
  CSV: 'csv',
  XLSX: 'xlsx',
  PDF: 'pdf',
};

export function previewModeToEmailReportFormat(mode, exportKind) {
  if (exportKind === 'full' || mode === 'both') {
    return EmailReportFormat.XLSX;
  }
  switch (mode) {
    case 'csv':
      return EmailReportFormat.CSV;
    case 'excel':
      return EmailReportFormat.XLSX;
    case 'pdf':
      return EmailReportFormat.PDF;
    default:
      return EmailReportFormat.XLSX;
  }
}

export function exportKindToEmailReportType(exportKind) {
  switch (exportKind) {
    case 'full':
      return EmailReportType.FULL;
    case 'dso':
      return EmailReportType.BY_COMPANY;
    case 'display':
      return EmailReportType.BY_DISPLAY;
    case 'zone':
      return EmailReportType.BY_ZONE;
    default:
      return EmailReportType.FULL;
  }
}

export function buildCostBreakdownEmailBody({
  campaignId,
  reportType,
  reportFormat,
  headers,
  rows,
}) {
  return {
    campaignId,
    reportType,
    reportFormat,
    report: {
      headers,
      rows,
    },
  };
}
